<template>
  <section>
    <div class="row">
      <div id="loadingmessage"
        style="text-align:center;margin: 0px; padding: 0px; position: fixed; right: 0px; top: 0px; width: 100%; height: 100%; background-color: white; z-index: 30001; opacity: 0.8;"
        v-if="loading">
        <p style="position: absolute; color: White; top: 40%; left: 50%;">
          <img src="../../assets/loader.gif" />
        </p>
      </div>
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              SIGHTINGS DETAILS &nbsp;
              <router-link :to="'/sightingsloc1/' + this.id">
                <span>
                  <i style="color:red!important" class="fa fa-map-marker"></i>
                </span>
              </router-link>
            </h4>
            <div class="row pt-4">
              <div class="col-2">
                <div class="row pl-3">
                  <output class="flex md12">
                    <img :src="image" v-if="im" style="width:150px;height:150px;" />
                    <p v-else>No image...</p>
                    <!-- <router-link :to="'/editmyprofile/'+this.userid"> <span class="flex md12 " align="right"><i class="fa fa-pencil"></i></span></router-link> -->
                  </output>
                </div>
              </div>

              <div class="col-md-6">
                <table class="table table-white flex md12">
                  <thead>
                    <tr></tr>
                  </thead>
                  <tbody>
                    <tr v-if="tname != '' || tname == !undefined">
                      <th scope="col">Turtle</th>
                      <td>{{ tname }}</td>
                    </tr>
                    <tr>
                      <th scope="col">Purpose</th>
                      <td>{{ purpose }}</td>
                    </tr>
                    <tr v-if="nearestcity">
                      <th scope="col">Nearest City</th>
                      <td>{{ nearestcity }}</td>
                    </tr>
                    <tr v-if="state">
                      <th scope="col">State</th>
                      <td>{{ state }}</td>
                    </tr>
                    <tr v-if="uname">
                      <th v-if="purpose == 'rescue'" class="text-capitalize" scope="col"> Rescued By</th>
                      <th v-if="purpose == 'observation'" class="text-capitalize" scope="col"> Observed By</th>
                      <td>{{ uname }}</td>
                    </tr>
                    <tr v-if="sightingData.userid.email">
                      <th v-if="purpose == 'rescue'" class="text-capitalize" scope="col"> Rescuer Email</th>
                      <th v-if="purpose == 'observation'" class="text-capitalize" scope="col"> Observer Email</th>
                      <td>{{ sightingData.userid.email }}</td>
                    </tr>
                    <tr v-if="sightingData.userid.phone">
                      <th v-if="purpose == 'rescue'" class="text-capitalize" scope="col"> Rescuer Phone</th>
                      <th v-if="purpose == 'observation'" class="text-capitalize" scope="col"> Observer Phone</th>
                      <td>{{ sightingData.userid.phone }}</td>
                    </tr>
                    <tr v-if="condition">
                      <th scope="col">Condition</th>
                      <td>{{ condition }}</td>
                    </tr>
                    <tr v-if="lifestage">
                      <th scope="col">Life Stage</th>
                      <td>{{ lifestage }}</td>
                    </tr>

                    <tr v-if="comment">
                      <th scope="col">Comment</th>
                      <td>{{ comment }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- <div class="col-5">
                <table class="table table-white flex md12">
                
                  <tbody>
                    <tr v-if="purpose=='observation' && uname">
                      <th scope="col">Observed By</th>
                      <td>{{uname}}</td>
                    </tr>
                    <tr v-if="purpose=='rescue' && uname">
                      <th scope="col">Rescued By</th>
                      <td>{{uname}}</td>
                    </tr>
                    <tr>
                      <th scope="col">Purpose</th>
                      <td>{{purpose}}</td>
                    </tr>
                    <tr v-if="condition">
                      <th scope="col">Condition</th>
                      <td>{{condition}}</td>
                    </tr>
                    <tr v-if="lifestage">
                      <th scope="col">LifeStage</th>
                      <td>{{lifestage}}</td>
                    </tr>

                    <tr v-if="comment">
                      <th scope="col">comment</th>
                      <td>{{comment}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  name: "myprofile",
  props: ["id"],
  data() {
    return {
      sightingData: [],
      purpose: "",
      lifestage: "",
      condition: "",
      uname: "",
      nearestcity: "",
      state: "",
      type: "",
      image: null,
      tname: "",
      id: "",
      comment: "",
      situation: "",
      loading: false,
      data: [],
      im: '',
    };
  },
  mounted: function () {
    this.getview();
  },

  methods: {
    getview() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/report/get",
        params: { id: this.id }
      })
        .then(response => {
          if (response.data.status === true) {
            this.sightingData = response.data.data
            this.purpose = response.data.data.purpose;
            this.name = response.data.data.name;
            this.condition = response.data.data.condition;
            this.lifestage = response.data.data.lifestage;
            this.nearestcity = response.data.data.nearestcity;
            this.state = response.data.data.state;
            this.type = response.data.data.type;
            this.comment = response.data.data.comment;
            this.situation = response.data.data.situation;
            this.im = response.data.data.image
            this.uname = response.data.data.userid.name;
            this.id = response.data.data._id;
            if (response.data.data.image !== null) {
              this.image = imageURL + response.data.data.image;
            }
            this.tname = response.data.data.turtle.name;
            this.visible = false;
          } else if (response.data.status === false) {
            this.visible = false;
          }
        })
        .catch(err => {
          this.errors.push(err);
          alert("No Network Found!!");
        });
    }
  }
};
</script>
<style>
.circular--square {
  border-top-left-radius: 50% 50%;
  border-top-right-radius: 50% 50%;
  border-bottom-right-radius: 50% 50%;
  border-bottom-left-radius: 50% 50%;
}
</style>